import BeneficioFarmacia from "@/pages/beneficio-farmacia/index.vue";

const routes: Route[] = [
  {
    path: "/plano-de-medicamentos",
    name: "beneficio_farmacia",
    component: BeneficioFarmacia,
    meta: {
      backTo: "/",
      checkPathDisabled: true,
      registerAccess: {
        servico: "Plano de medicamentos",
        funcionalidade: "Acesso ao plano de medicamentos"
      }
    }
  }
];

export default routes;
